<div id="doctors-list" class="flex flex-col gap-3">
  <div class="flex flex-row justify-between">
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
    <div class="flex flex-row gap-3 w-full justify-end">
      <button mat-flat-button color="primary" class="w-1/4" (click)="exportReport()">Export Report</button>
      @if (!reportId) {
        <button mat-flat-button color="primary" class="w-1/4" (click)="submitReport()">Save as Draft</button>
      } @else {
        @if (report?.status === ReportStatus.DRAFT) {
          <button mat-stroked-button color="primary" class="w-1/4" (click)="updateReport(true)">Finalize</button>
        }
        <button mat-flat-button color="primary" class="w-1/4" (click)="updateReport()">Update</button>
      }
    </div>
  </div>
  <div class="card flex p-5">
    <form class="reportForm flex flex-col gap-8" [formGroup]="reportForm">
      <div class="flex flex-row justify-between">
        <div class="left-side">
          @for (item of field1; track item.name) {
            <div class="report-input">
              <label [for]="item.name">{{ item.name | titlecase }}</label>
              <input [id]="item.name" class="small-input" type="number" [formControlName]="item.name">
            </div>
          }
        </div>
        <div class="flex flex-col justify-between h-full w-full">
          <div class="w-full">
            <div class="flex flex-row-reverse gap-2 items-center">
              <input id="skin_age" class="small-input" type="number" formControlName="skin_age">
              <label for="skin_age">Skin Age</label>
            </div>
          </div>
          <div id="diversity_index" class="p-4">
            <h3>Diversity Index</h3>
            <mat-slider min="0" max="1" step="0.01" showTickMarks discrete>
              <input matSliderThumb formControlName="diversity_index">
            </mat-slider>
          </div>
        </div>
      </div>
      <div class="flex w-full justify-between">
        <h1 class="flex-1">Relative Abundance</h1>
        <mat-select class="flex-1" name="country"
                    [value]="'austria'">
          <mat-option [value]="'austria'">Austria</mat-option>
        </mat-select>
      </div>
      <div class="flex flex-row justify-between">
        <div class="left-side">
          @for (item of field2; track item.name) {
            <div class="report-input">
              <label [for]="item.name">{{ item.name | titlecase }}</label>
              <input [id]="item.name" class="small-input" type="number" [formControlName]="item.name">
            </div>
          }
        </div>
        <div class="flex h-full w-full justify-center">
          <app-bar-chart [myGraphData]="formNumbers"/>
        </div>
      </div>
      <div class="flex w-full mt-10 mb-8">
        <h1 class="flex-1">Skin Profile</h1>
      </div>
      <div class="flex flex-col gap-3">
        <div class="flex w-full gap-16 justify-between">
          <div class="flex flex-col gap-6 flex-1">
            <div class="flex flex-row justify-between">
              <div class="flex flex-col">
                <label>
                  Acne
                </label>
                <mat-button-toggle-group
                  name="acne"
                  aria-label="acne"
                  formControlName="acne"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="no">No</mat-button-toggle>
                  <mat-button-toggle value="mild">Mild</mat-button-toggle>
                  <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                  <mat-button-toggle value="severe">Severe</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <!--            <div class="flex flex-col">-->
              <!--              <label>-->
              <!--                Acne Percentage-->
              <!--              </label>-->
              <!--              <mat-select placeholder="Acne Percentage" formControlName="acne_percentage">-->
              <!--                @for (item of acnePercentage; track item) {-->
              <!--                  <mat-option [value]="item">{{ item }}%</mat-option>-->
              <!--                }-->
              <!--              </mat-select>-->
              <!--            </div>-->
            </div>
            <div class="flex flex-col">
              <label>
                Recommendations for Acne
              </label>
              <textarea formControlName="acne_recommendation"></textarea>
            </div>
            <div class="flex flex-row justify-between gap-3">
              <div class="flex flex-col">
                <label>
                  Pigmentation
                </label>
                <mat-button-toggle-group
                  name="pigmentation"
                  aria-label="pigmentation"
                  formControlName="pigmentation"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="no">No</mat-button-toggle>
                  <mat-button-toggle value="mild">Mild</mat-button-toggle>
                  <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                  <mat-button-toggle value="severe">Severe</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <div class="flex flex-col">
                <label>
                  SPF recommendation
                </label>
                <mat-select placeholder="SPF recommendation" formControlName="spf">
                  @for (item of spfOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div formGroupName="pigmentation_details">
              <div class="flex w-full justify-between gap-3 mt-3">
                <div class="w-full">
                  <label>
                    Eye area
                  </label>
                  <mat-select placeholder="Select..." formControlName="eye_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="w-full">
                  <label>
                    Overall face
                  </label>
                  <mat-select placeholder="Select..." formControlName="overall_face">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="flex w-full justify-between gap-3 mt-5">
                <div class="w-full">
                  <label>
                    Malar area
                  </label>
                  <mat-select placeholder="Select..." formControlName="malar_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="w-full">

                </div>
              </div>
              <div class="flex flex-col mt-5">
                <label>
                  Recommendations for Pigmentation
                </label>
                <textarea formControlName="pigmentation_recommendations"></textarea>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-6 flex-1">
            <div class="flex flex-row justify-between">
              <div class="flex flex-col">
                <label>
                  Skin type
                </label>
                <mat-button-toggle-group
                  name="skin_type"
                  aria-label="skin_type"
                  formControlName="skin_type"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="normal">Normal</mat-button-toggle>
                  <mat-button-toggle value="dry">Dry</mat-button-toggle>
                  <mat-button-toggle value="oily">oily</mat-button-toggle>
                  <mat-button-toggle value="combination">Combination</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <div></div>
            </div>
            <div class="flex flex-col">
              <label>
                Recommendations for Skin
              </label>
              <textarea formControlName="skin_recommendation"></textarea>
            </div>
            <div class="flex flex-row justify-between">
              <div class="flex flex-col">
                <label>
                  Wrinkles
                </label>
                <mat-button-toggle-group
                  name="wrinkles"
                  aria-label="wrinkles"
                  formControlName="wrinkles"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="no">No</mat-button-toggle>
                  <mat-button-toggle value="mild">Mild</mat-button-toggle>
                  <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                  <mat-button-toggle value="severe">Severe</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>

            <div formGroupName="wrinkles_details">
              <div class="flex w-full justify-between gap-3 mt-5">
                <div class="w-full">
                  <label>
                    Eye area
                  </label>
                  <mat-select placeholder="Select..." formControlName="eye_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="w-full">
                  <label>
                    Forehead
                  </label>
                  <mat-select placeholder="Select..." formControlName="forehead_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="flex w-full justify-between gap-3 mt-5">
                <div class="w-full">
                  <label>
                    Nose area
                  </label>
                  <mat-select placeholder="Select..." formControlName="nose_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="w-full">
                  <label>
                    Lips area
                  </label>
                  <mat-select placeholder="Select..." formControlName="lips_area">
                    @for (item of levelOptions; track item) {
                      <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="flex flex-col mt-5">
                <label>
                  Wrinkles recommendations
                </label>
                <textarea formControlName="wrinkles_recommendations"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col mt-5">
          <label>
            Additional Notes
          </label>
          <textarea formControlName="extra_notes"></textarea>
        </div>
      </div>
      <!--      <div class="flex w-full gap-16 justify-between">-->
      <!--        <div class="flex flex-col gap-6 flex-1">-->
      <!--          <div class="flex flex-row justify-between">-->
      <!--            <div class="flex flex-col">-->
      <!--              <label>-->
      <!--                Acne-->
      <!--              </label>-->
      <!--              <mat-button-toggle-group-->
      <!--                name="acne"-->
      <!--                aria-label="acne"-->
      <!--                formControlName="acne"-->
      <!--                [hideSingleSelectionIndicator]="true"-->
      <!--              >-->
      <!--                <mat-button-toggle value="no">No</mat-button-toggle>-->
      <!--                <mat-button-toggle value="mild">Mild</mat-button-toggle>-->
      <!--                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>-->
      <!--                <mat-button-toggle value="severe">Severe</mat-button-toggle>-->
      <!--              </mat-button-toggle-group>-->
      <!--            </div>-->
      <!--            <div class="flex flex-col">-->
      <!--              <label>-->
      <!--                Acne Percentage-->
      <!--              </label>-->
      <!--              <mat-select placeholder="Acne Percentage" formControlName="acne_percentage">-->
      <!--                @for (item of acnePercentage; track item) {-->
      <!--                  <mat-option [value]="item">{{ item }}%</mat-option>-->
      <!--                }-->
      <!--              </mat-select>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="flex flex-col">-->
      <!--            <label>-->
      <!--              Recommendations for Acne-->
      <!--            </label>-->
      <!--            <textarea formControlName="acne_recommendation"></textarea>-->
      <!--          </div>-->
      <!--          <div class="flex flex-row justify-between">-->
      <!--            <div class="flex flex-col">-->
      <!--              <label>-->
      <!--                Pigmentation-->
      <!--              </label>-->
      <!--              <mat-button-toggle-group-->
      <!--                name="pigmentation"-->
      <!--                aria-label="pigmentation"-->
      <!--                formControlName="pigmentation"-->
      <!--                [hideSingleSelectionIndicator]="true"-->
      <!--              >-->
      <!--                <mat-button-toggle value="no">No</mat-button-toggle>-->
      <!--                <mat-button-toggle value="mild">Mild</mat-button-toggle>-->
      <!--                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>-->
      <!--                <mat-button-toggle value="severe">Severe</mat-button-toggle>-->
      <!--              </mat-button-toggle-group>-->
      <!--            </div>-->
      <!--            <div></div>-->
      <!--          </div>-->
      <!--          <div>-->
      <!--            <label>-->
      <!--              Extra Notes-->
      <!--            </label>-->
      <!--            <textarea formControlName="extra_notes"></textarea>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="flex flex-col gap-6 flex-1">-->
      <!--          <div class="flex flex-row justify-between">-->
      <!--            <div class="flex flex-col">-->
      <!--              <label>-->
      <!--                Skin type-->
      <!--              </label>-->
      <!--              <mat-button-toggle-group-->
      <!--                name="skin_type"-->
      <!--                aria-label="skin_type"-->
      <!--                formControlName="skin_type"-->
      <!--                [hideSingleSelectionIndicator]="true"-->
      <!--              >-->
      <!--                <mat-button-toggle value="normal">Normal</mat-button-toggle>-->
      <!--                <mat-button-toggle value="dry">Dry</mat-button-toggle>-->
      <!--                <mat-button-toggle value="oily">oily</mat-button-toggle>-->
      <!--                <mat-button-toggle value="combination">Combination</mat-button-toggle>-->
      <!--              </mat-button-toggle-group>-->
      <!--            </div>-->
      <!--            <div></div>-->
      <!--          </div>-->
      <!--          <div class="flex flex-col">-->
      <!--            <label>-->
      <!--              Recommendations for Skin-->
      <!--            </label>-->
      <!--            <textarea formControlName="skin_recommendation"></textarea>-->
      <!--          </div>-->
      <!--          <div class="flex flex-row justify-between">-->
      <!--            <div class="flex flex-col">-->
      <!--              <label>-->
      <!--                Wrinkles-->
      <!--              </label>-->
      <!--              <mat-button-toggle-group-->
      <!--                name="wrinkles"-->
      <!--                aria-label="wrinkles"-->
      <!--                formControlName="wrinkles"-->
      <!--                [hideSingleSelectionIndicator]="true"-->
      <!--              >-->
      <!--                <mat-button-toggle value="no">No</mat-button-toggle>-->
      <!--                <mat-button-toggle value="mild">Mild</mat-button-toggle>-->
      <!--                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>-->
      <!--                <mat-button-toggle value="severe">Severe</mat-button-toggle>-->
      <!--              </mat-button-toggle-group>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="flex flex-col">-->
      <!--            <label>-->
      <!--              Wrinkles appears mostly on-->
      <!--            </label>-->
      <!--            <textarea formControlName="wrinkles_details"></textarea>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="flex w-full justify-between items-center">
        <h1 class="flex-1">Skin Index</h1>
        <mat-select [formControlName]="'skin_index'" name="skin_index" value="OSNW">
          @for (item of skinIndexList; track item) {
            <mat-option [value]="item">{{ item }}</mat-option>
          }
          <!--          <mat-option [value]="'OSNW'">OSNW</mat-option>-->
        </mat-select>
      </div>
      <div class="flex w-full flex-col gap-3">
        <h1 class="flex-1">Routine</h1>
        <button mat-flat-button color="primary" class="flex justify-items-start text-left" type="button"
                (click)="openModal()">
          <mat-icon>add</mat-icon>
          Add Products
        </button>
        @if (!!products) {
          @for (product of products; track product['id']) {
            <div class="custom-btn rounded-lg">
              <div class="flex flex-row justify-between p-3 cursor-pointer items-center">
                <img [src]="product.image_url" alt="" height="30px" width="auto">
                <p class="flex-1 ml-3">{{ product.name }}</p>
                <p>{{ product.application_time }}</p>
              </div>
            </div>
          }
        } @else {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
    </form>
  </div>
</div>
<app-modal *ngIf="isModalVisible">
  <div class="flex flex-col gap-8 modal-body">
    <div class="flex flex-row justify-between">
      <h1>Product Details</h1>
      <button mat-icon-button (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="w-full flex flex-col gap-3 overflow-y-scroll">
      @if (!!allProducts) {
        @for (product of allProducts; track product['id']) {
          <div class="custom-btn rounded-lg" (click)="selectProduct(product)"
               [ngClass]="{'selected-product': selectedProducts.includes(product)}">
            <div class="flex flex-row justify-between p-3 cursor-pointer items-center">
              <img [src]="product.image_url" alt="" height="30px" width="auto">
              <p class="flex-1 ml-3">{{ product.name }}</p>
              <p>{{ product.application_time }}</p>
            </div>
          </div>
        }
      } @else {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    <div class="flex flex-row justify-between gap-8">
      <button mat-flat-button color="primary" type="button" class="w-full" (click)="gotoProductsPage()">
        <mat-icon>add</mat-icon>
        Add New
      </button>
      <button mat-flat-button color="primary" type="button" class="w-full" (click)="addProducts()">
        <mat-icon>add</mat-icon>
        Save List
      </button>
    </div>
  </div>
</app-modal>
